import { render, staticRenderFns } from "./NgWidget.vue?vue&type=template&id=2a55ae86"
import script from "./NgWidget.vue?vue&type=script&lang=js"
export * from "./NgWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports